import type {TimeZone} from 'timezones-list';

export interface TimezoneProps {
  mobileDropdownClick?: () => void; // If the dropdown is clicked while in mobile view
  onSelectTimeZone?: (timeZone: TimeZone) => void;
}

export const timezoneDropdownId = 'Timezone';
